// @flow
import React from 'react'

import styles from './MultipleModalAdditionalContent.scss'

const MultipleModalAdditionalContent = () => {
  return (
    <span className={styles.root}>
      {
        'Изменение общих настроек займет продолжительное время. Новые настройки вступят в силу в течении от нескольких минут до нескольких часов, в зависимости от количества заведений'
      }
    </span>
  )
}

export default MultipleModalAdditionalContent
